'use client';

import React from 'react';
import AiSummaryWidget from 'ui/src/components/AiSummaryWidget';
import getPrompt from './utils/getPrompt';

interface Props {
  url: string;
}

export default function PostAiButton({ url }: Props) {
  return (
    <AiSummaryWidget
      prompt={getPrompt(url)}
      label="Summarize with AI"
      labelClassName="site-paragraph-s"
      direction="toBottom"
    />
  );
}
